/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
import { Component, ViewEncapsulation, HostListener, TemplateRef, ContentChild } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";

import { SidebarService, PageService } from "@auth/services";

@Component({
  selector: "authenticated-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  host: {
    class: "authenticated-sidebar",
  },
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  constructor(private pageService: PageService, public sidebarService: SidebarService, public deviceService: DeviceDetectorService) {}
  @ContentChild("sidebarHeader", { static: false }) sidebarHeader: TemplateRef<void>;
  @ContentChild("menuItems", { static: false }) menuItems: TemplateRef<void>;

  tabExclusions = ["input", "textarea", "button", "a", "select", "mat-select", "td"];

  @HostListener("document:keydown", ["$event"])
  handleKeydownEvent(event: KeyboardEvent) {
    if (event.key == "Tab") {
      let elem = event.srcElement["tagName"] || null;
      if (elem) elem = elem.toLowerCase();
      if (!this.tabExclusions.includes(elem)) {
        event.stopPropagation();
        event.preventDefault();
        this.sidebarService.focus("tab");
      }
    }
  }

  @HostListener("document:keyup", ["$event"])
  handleKeyupEvent(event: KeyboardEvent) {
    if (event.key == "Tab") {
      let elem = event.srcElement["tagName"] || null;
      if (elem) elem = elem.toLowerCase();
      if (!this.tabExclusions.includes(elem)) {
        // console.log(elem);
        event.stopPropagation();
        event.preventDefault();
        this.sidebarService.blur("tab");
      }
    }
  }

  @HostListener("mouseenter", ["$event"]) handleMouseEnterEvent() {
    this.sidebarService.focus("mouse");
  }

  @HostListener("mouseleave", ["$event"]) handleMouseOutEvent() {
    this.sidebarService.blur("mouse");
  }
}
